// extracted by mini-css-extract-plugin
module.exports = {"root":"LargeImageBlock-module--root---m8x4","image":"LargeImageBlock-module--image--Ch9EN","isPanorama":"LargeImageBlock-module--isPanorama--211nA"};